import React, { useContext, useState } from 'react';
import ajaxCard from '../util/remote/ajaxCard';
import SchoolContext from './SchoolContext';

const CardContext = React.createContext();

export const CardConsumer = CardContext.Consumer;

export const CardProvider = (props)=> {
  const [cardList, setCardList] = useState([]);
  const [printableCards, setPrintableCards] = useState([]);

  const [assignedCardList, setAssignedCardList] = useState([]);
  const [schoolAssignedCardList, setSchoolAssignedCardList] = useState([]);

  const [unassignedCardList, setUnassignedCardList] = useState([]);
  const [inactiveCardList, setInactiveCardList] = useState([]);
  const [lostCardList, setLostCardList] = useState([]);


  const [page,setPage] = useState(1)
  const [assignedPage,setAssignedPage] = useState(1)
  const [unassignedPage,setUnassignedPage] = useState(1)
  const [inactivePage,setInactivePage] = useState(1)
  const [lostPage,setLostPage] = useState(1)


  const [meta,setMeta] = useState([])
  const [assignedMeta,setAssignedMeta] = useState([])
  const [unassignedMeta,setUnassignedMeta] = useState([])
  const [inactiveMeta,setInactiveMeta] = useState([])
  const [lostMeta,setLostMeta] = useState([])
  
  const [first, setFirst] = useState("");
  const [assignedFirst, setAssignedFirst] = useState("");
  const [unassignedFirst, setUnassignedFirst] = useState("");
  const [inactiveFirst, setInactiveFirst] = useState("");
  const [lostFirst, setLostFirst] = useState("");

  const [query, setQuery] = useState("");
  const [assignedQuery, setAssignedQuery] = useState("");
  const [unassignedQuery, setUnassignedQuery] = useState("");
  const [inactiveQuery, setInactiveQuery] = useState("");
  const [lostQuery, setLostQuery] = useState("");

  const [allCardsCount, setAllCardsCount] = useState(false);
  const [cardsCount, setCardsCount] = useState(false);
  const [wristbandsCount, setWristbandsCount] = useState(false);

  const [assignedCardsCount, setAssignedCardsCount] = useState(false);
  const [assignedWristbandsCount, setAssignedWristbandsCount] = useState(false);
  
  const [schoolAssignedCardsCount, setSchoolAssignedCardsCount] = useState(false);
  const [schoolAssignedWristbandsCount, setSchoolAssignedWristbandsCount] = useState(false);


  const [inactiveCardsCount, setInactiveCardsCount] = useState(false);
  const [unassignedCardsCount, setUnassignedCardsCount] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const { schoolDetails } = useContext(SchoolContext);

  const schoolID = schoolDetails.school_id;
  const getCards = async (currentPage) => {
      setLoading(true)
      const server_response = await ajaxCard.fetchCardList(currentPage);
      setLoading(false)
      if (server_response.status === "OK") {
        setFirst(server_response.details.meta.offset);
        setMeta(server_response.details.meta.totalPages);
        setCardList(server_response.details.data || []);
      } else {
        setCardList([]);
      }
  };

  const getAssignedCards = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxCard.fetchAssignedCardList(currentPage);
    setLoading(false);
    if (server_response.status === "OK") {
      setAssignedFirst(server_response.details.meta.offset);
      setAssignedMeta(server_response.details.meta.totalPages);
      setAssignedCardList(server_response.details.data || []);
    } else {
      setAssignedCardList([]);
    }
  };

  const getSchoolAssignedCards = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxCard.fetchSchoolAssignedCardList(currentPage, schoolID);
    setLoading(false);
    if (server_response.status === "OK") {
      setAssignedFirst(server_response.details.meta.offset);
      setAssignedMeta(server_response.details.meta.totalPages);
      setSchoolAssignedCardList(server_response.details.data || []);
    } else {
      setSchoolAssignedCardList([]);
    }
  };

  const getLostCards = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxCard.fetchLostCardList(currentPage);
    setLoading(false);
    if (server_response.status === "OK") {
      setLostFirst(server_response.details.meta.offset_count);
      setLostMeta(server_response.details.meta.list_of_pages);
      setLostCardList(server_response.details.list || []);
    } else {
      setLostCardList([]);
    }
  };

  const getUnassignedCards = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxCard.fetchUnassignedCardList(currentPage);
    setLoading(false);
    if (server_response.status === "OK") {
      setUnassignedFirst(server_response.details.meta.offset_count);
      setUnassignedMeta(server_response.details.meta.list_of_pages);
      setUnassignedCardList(server_response.details.list || []);
    } else {
      setUnassignedCardList([]);
    }
  };

  const getInactiveCards = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxCard.fetchInactiveCardList(currentPage);
    setLoading(false);
    if (server_response.status === "OK") {
      setInactiveFirst(server_response.details.meta.offset);
      setInactiveMeta(server_response.details.meta.totalPages);
      setInactiveCardList(server_response.details.data || []);
    } else {
      setInactiveCardList([]);
    }
  };

  const searchCard = async (e) => {
      if (e) {
        e.preventDefault();
      }
      setLoading2(true)
        const server_response = await ajaxCard.searchCard(query,page);
        setLoading2(false)
        if (server_response.status === "OK") {
          setFirst(server_response.details.meta.offset);
          setMeta(server_response.details.meta.totalPages);
          setCardList(server_response.details.data || []);
        } else {
          setCardList([]);
        }
  };

  const searchAssignedCard = async (e) => {
    if (e) {
      e.preventDefault();
    }
      setLoading2(true);
      const server_response = await ajaxCard.searchAssignedCard(assignedQuery,assignedPage);
      setLoading2(false);
      if (server_response.status === "OK") {
        setAssignedFirst(server_response.details.meta.offset);
        setAssignedMeta(server_response.details.meta.totalPages);
        setAssignedCardList(server_response.details.data || []);
      } else {
        setAssignedCardList([]);
      }
  };

  const searchSchoolAssignedCard = async (e) => {
    if (e) {
      e.preventDefault();
    }
      setLoading2(true);
      const server_response = await ajaxCard.searchSchoolAssignedCard(assignedQuery,assignedPage,schoolID);
      setLoading2(false);
      if (server_response.status === "OK") {
        setAssignedFirst(server_response.details.meta.offset);
        setAssignedMeta(server_response.details.meta.totalPages);
        setSchoolAssignedCardList(server_response.details.data || []);
      } else {
        setSchoolAssignedCardList([]);
      }
  };

  const searchUnassignedCard = async (e) => {
    if (e) {
      e.preventDefault();
    }
      setLoading2(true);
      const server_response = await ajaxCard.searchUnassignedCard(unassignedQuery,unassignedPage);
      setLoading2(false);
      if (server_response.status === "OK") {
        setUnassignedFirst(server_response.details.meta.offset_count);
        setUnassignedMeta(server_response.details.meta.list_of_pages);
        setUnassignedCardList(server_response.details.list || []);
      } else {
        setUnassignedCardList([]);
      }
  };

  const searchInactiveCard = async (e) => {
    if (e) {
      e.preventDefault();
    }
      setLoading2(true);
      const server_response = await ajaxCard.searchInactiveCard(inactiveQuery,inactivePage);
      setLoading2(false);
      if (server_response.status === "OK") {
        setInactiveFirst(server_response.details.meta.offset);
        setInactiveMeta(server_response.details.meta.totalPages);
        setInactiveCardList(server_response.details.data || []);
      } else {
        setInactiveCardList([]);
      }
  };

  const searchLostCard = async (e) => {
    if (e) {
      e.preventDefault();
    }
      setLoading2(true);
      const server_response = await ajaxCard.searchLostCard(lostQuery,lostPage);
      setLoading2(false);
      if (server_response.status === "OK") {
        setLostFirst(server_response.details.meta.offset_count);
        setLostMeta(server_response.details.meta.list_of_pages);
        setLostCardList(server_response.details.list || []);
      } else {
        setLostCardList([]);
      }
  };

  const countAllCards = async () => {
    const server_response = await ajaxCard.countAllCards();
    if (server_response.status === "OK") {
      setAllCardsCount(server_response.details);
    } else {
      setAllCardsCount("404");
    }
  };

  const countOnlyCards = async () => {
    const server_response = await ajaxCard.countCards();
    if (server_response.status === "OK") {
      setCardsCount(server_response.details);
    } else {
      setCardsCount("404");
    }
  };

  const countOnlyWristbands = async () => {
    const server_response = await ajaxCard.countWristbands();
    if (server_response.status === "OK") {
      setWristbandsCount(server_response.details);
    } else {
      setWristbandsCount("404");
    }
  };

  const countInactiveCards = async () => {
    const server_response = await ajaxCard.countInactiveCards();
    if (server_response.status === "OK") {
      setInactiveCardsCount(server_response.details);
    } else {
      //communicate error
      setInactiveCardsCount("404");
    }
  };

  const countUnassignedCards = async () => {
    const server_response = await ajaxCard.countUnassignedCards();
    if (server_response.status === "OK") {
      setUnassignedCardsCount(server_response.details);
    } else {
      //communicate error
      setUnassignedCardsCount("404");
    }
  };

  const countAssignedCards = async () => {
    const server_response = await ajaxCard.countAssignedCards();
    if (server_response.status === "OK") {
      setAssignedCardsCount(server_response.details);
    } else {
      setAssignedCardsCount("404");
    }
  };

  const countAssignedWristbands = async () => {
    const server_response = await ajaxCard.countAssignedWristbands();
    if (server_response.status === "OK") {
      setAssignedWristbandsCount(server_response.details);
    } else {
      setAssignedWristbandsCount("404");
    }
  };

  const countSchoolAssignedCards = async () => {
    setSchoolAssignedCardsCount(false);
    const server_response = await ajaxCard.countSchoolAssignedCards(schoolID);
    if (server_response.status === "OK") {
      setSchoolAssignedCardsCount(server_response.details);
    } else {
      //communicate error
      setSchoolAssignedCardsCount("404");
    }
  };

  const countSchoolAssignedWristbands = async () => {
    setSchoolAssignedWristbandsCount(false);
    const server_response = await ajaxCard.countSchoolAssignedWristbands(schoolID);
    if (server_response.status === "OK") {
      setSchoolAssignedWristbandsCount(server_response.details);
    } else {
      //communicate error
      setSchoolAssignedWristbandsCount("404");
    }
  };

  const getPrintableCards = async () => {
    const server_response = await ajaxCard.listAllCards();
    if (server_response.status === "OK") {
      setPrintableCards(server_response.details);
    } else {
      setPrintableCards("404");
    }
  };


    
  return (
    <CardContext.Provider value={
      {
        cardList,
        printableCards,
        first,
        assignedFirst,
        unassignedFirst,
        inactiveFirst,
        lostFirst,
        meta,
        assignedMeta,
        unassignedMeta,
        inactiveMeta,
        lostMeta,
        inactiveQuery,
        unassignedQuery,
        assignedQuery,
        lostQuery,
        query,
        page,
        assignedPage,
        unassignedPage,
        inactivePage,
        lostPage,
        loading,
        loading2,
        allCardsCount,
        cardsCount,
        wristbandsCount,
        inactiveCardsCount,
        unassignedCardsCount,
        assignedCardsCount,
        assignedWristbandsCount,
        schoolAssignedCardsCount,
        schoolAssignedWristbandsCount,
        assignedCardList,
        schoolAssignedCardList,
        unassignedCardList,
        inactiveCardList,
        lostCardList,
        schoolID,
        setInactiveCardList,
        setUnassignedCardList,
        setAssignedCardList,
        setSchoolAssignedCardList,
        setCardList,
        setLostCardList,
        setAllCardsCount,
        setCardsCount,
        setWristbandsCount,
        setAssignedCardsCount,
        setAssignedWristbandsCount,
        setSchoolAssignedCardsCount,
        setSchoolAssignedWristbandsCount,
        setInactiveCardsCount,
        setUnassignedCardsCount,
        setPage,
        setMeta,
        setFirst,
        setQuery,
        setAssignedPage,
        setAssignedMeta,
        setAssignedFirst,
        setAssignedQuery,
        setUnassignedPage,
        setUnassignedMeta,
        setUnassignedFirst,
        setUnassignedQuery,
        setInactivePage,
        setInactiveMeta,
        setInactiveFirst,
        setInactiveQuery,
        setLostFirst,
        setLostPage,
        setLostMeta,
        setLostQuery,
        getCards,
        searchCard,
        countAllCards,
        countOnlyCards,
        countOnlyWristbands,
        countInactiveCards,
        countAssignedCards,
        countAssignedWristbands,
        countSchoolAssignedCards,
        countSchoolAssignedWristbands,
        countUnassignedCards,
        getAssignedCards,
        searchAssignedCard,
        getSchoolAssignedCards,
        searchSchoolAssignedCard,
        getUnassignedCards,
        searchUnassignedCard,
        getInactiveCards,
        searchInactiveCard,
        getLostCards,
        searchLostCard,
        getPrintableCards

      }
    }>
    {props.children}
    </CardContext.Provider>
  );
    
}

export default CardContext;